/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // Intercept history pushState/replaceState to remove sort_by=relevance from URL
const _pushState = history.pushState.bind(history);
const _replaceState = history.replaceState.bind(history);

function removeSortParam(url) {
  if (!url) return url;
  const u = new URL(url.toString(), window.location.origin);
  if (u.searchParams.get('sort_by') === 'relevance') {
    u.searchParams.delete('sort_by');
  }
  return u.toString();
}

history.pushState = function(state, title, url) {
  _pushState(state, title, removeSortParam(url));
};

history.replaceState = function(state, title, url) {
  _replaceState(state, title, removeSortParam(url));
};

// Watch for Globo app to inject the search form, then keep action attribute clean
const observer = new MutationObserver(function() {
  const form = document.querySelector('.gf-controls-search-form');
  const sortToggle = document.querySelector('.sort-by-toggle span');
  if (!form || !sortToggle) return;

  if (sortToggle.textContent.trim() === 'Relevance') {
    const defaultSortOption = document.querySelector('[data-sort="created-descending"]');
    if (defaultSortOption) {
      defaultSortOption.click();
    }
  }

  const actionObserver = new MutationObserver(function() {
    const action = form.getAttribute('action');
    if (action && action.includes('sort_by=relevance')) {
      const u = new URL(action);
      u.searchParams.delete('sort_by');
      form.setAttribute('action', u.toString());
    }
  });

  actionObserver.observe(form, { attributes: true, attributeFilter: ['action'] });

  const sortInput = form.querySelector('input[name="sort_by"]');
  if (sortInput) sortInput.value = '';
});

observer.observe(document.body, { childList: true, subtree: true });




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
